/* eslint-disable @typescript-eslint/no-explicit-any */
import { apiCall, METHOD } from '../../service/baseApiCall'
import {
  QUESTION_CREATE,
  QUESTION_LIST,
  QUESTION_UPDATE,
  QUESTION_DETAILS,
  QUESTION_DELETE,
  SUBJECT_LIST,
  TOPIC_LIST,
  QUESTION_BULK_UPLOAD,
  QUESTIONNAIRE_UPLOAD,
  UPLOAD_QUESTIONNAIRE_HISTORY,
  QUESTIONNAIRE_LIST,
  QUESTIONNAIRE_DETAILS,
  QUESTIONNAIRE_DELETE,
  DELETE_UPLOAD_HISTORY,
  GET_QUESTION_PAPER,
  GET_EXAM_QUESTION,
  EXAM_TYPE_WISE_SUBJECT_LIST,
  SUBJECT_WISE_TOPIC_LIST,
} from '../constants/action-types'
import { ThunkAction } from 'redux-thunk'
import { Action, Store } from 'redux'
import {
  QUESTIONNAIRE_LIST_URL,
  QUESTION_BULK_UPLOAD_URL,
  QUESTION_URL,
  QUESTIONNAIRE_UPLOAD_HISTORY_URL,
  QUESTIONNAIRE_UPLOAD_URL,
  SUBJECT_URL,
  TOPIC_URL,
  QUESTIONNAIRE_DETAILS_URL,
  DELETE_UPLOAD_HISTORY_URL,
  GET_QUESTION_PAPER as GET_QUESTION_PAPER_URL,
  GET_EXAM_QUESTIONS_URL,
  EXAM_TYPE_WISE_SUBJECT_LIST_URL,
  SUBJECT_WISE_TOPICS_URL,
} from '../../service/apiEndPoints'
import { showErrorToastMessage, successToast } from '../../util/utils'
import { CancelTokenSource } from 'axios'

// ************** QUESTION_LIST ******************

export const questionList =
  (
    showToast = false,
    params?: Record<string, any>,
    cancelToken?: CancelTokenSource
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(questionListInit(showToast, params, cancelToken))
  }

export const questionListInit =
  (
    showToast: boolean,
    queryParams,
    cancelToken?: CancelTokenSource
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: QUESTION_LIST.QUESTION_LIST_INITIALIZATION,
    })
    const params = new URLSearchParams()
    if (queryParams) {
      Object.keys(queryParams)
        ?.filter((key) => key !== 'visibility')
        ?.map((key) => {
          queryParams[key] && params.append(key, queryParams[key])
        })
      if (queryParams?.visibility === 'All') {
        params.append('visibility', 'PUBLIC')
        params.append('visibility', 'PRIVATE')
      } else {
        params.append('visibility', queryParams.visibility)
      }
    }

    apiCall(
      QUESTION_URL,
      (res: any) => dispatch(questionListSuccess(res)),
      (err: any) => {
        dispatch(questionListError(err))
      },
      { params, cancelToken: cancelToken?.token },
      METHOD.GET,
      { showToast: showToast }
    )
  }

export const questionListSuccess =
  (res: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: QUESTION_LIST.QUESTION_LIST_SUCCESS,
      payload: res,
    })
  }

export const questionListError =
  (err: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: QUESTION_LIST.QUESTION_LIST_ERORR,
      payload: err.message,
    })
  }

// ************** CREATE QUESTION ******************

export const questionCreate =
  (
    showToast = true,
    questionData,
    _handleRedirect: () => void,
    _handleFailure: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(
      questionCreateInit(
        showToast,
        questionData,
        _handleRedirect,
        _handleFailure
      )
    )
  }

export const questionCreateInit =
  (
    showToast = true,
    questionData,
    _handleRedirect: () => void,
    _handleFailure: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: QUESTION_CREATE.QUESTION_CREATE_INITIALIZATION,
    })
    apiCall(
      QUESTION_URL,
      (res: any) =>
        dispatch(questionCreateSuccess(questionData, _handleRedirect)),
      (err: any) => {
        dispatch(questionCreateError(err, _handleFailure))
      },
      questionData,
      METHOD.POST,
      {
        showToast: showToast,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )
  }

export const questionCreateSuccess =
  (
    questionData: any,
    _handleRedirect
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: QUESTION_CREATE.QUESTION_CREATE_SUCCESS,
    })
    _handleRedirect()
  }

export const questionCreateError =
  (
    err: any,
    _handleFailure
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: QUESTION_CREATE.QUESTION_CREATE_ERORR,
      payload: err.message,
    })
    _handleFailure()
  }

// ************** UPDATE QUESTION ******************

export const questionUpdate =
  (
    showToast = true,
    payload,
    _handleRedirect: () => void,
    _handleFailure: () => void,
    questionId: number
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(
      questionUpdateInit(
        showToast,
        payload,
        _handleRedirect,
        _handleFailure,
        questionId
      )
    )
  }

export const questionUpdateInit =
  (
    showToast: boolean,
    payload,
    _handleRedirect: () => void,
    _handleFailure: () => void,
    questionId: number
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: QUESTION_UPDATE.QUESTION_UPDATE_INITIALIZATION,
    })
    apiCall(
      QUESTION_URL + `/${questionId}`,
      (res: any) => dispatch(questionUpdateSuccess(res, _handleRedirect)),
      (err: any) => {
        dispatch(questionUpdateError(err, _handleFailure))
      },
      payload,
      METHOD.PUT,
      { showToast: showToast }
    )
  }

export const questionUpdateSuccess =
  (
    res: any,
    _handleRedirect
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: QUESTION_UPDATE.QUESTION_UPDATE_SUCCESS,
      payload: res,
    })
    _handleRedirect()
  }

export const questionUpdateError =
  (
    err: any,
    _handleFailure
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: QUESTION_UPDATE.QUESTION_UPDATE_ERORR,
      payload: err.message,
    })
    showErrorToastMessage('Something went wrong.')
  }
// ************** QUESTION_DETAILS ******************

export const questionDetails =
  (ID: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(questionDetailsInit(ID))
  }

export const questionDetailsInit =
  (ID: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: QUESTION_DETAILS.QUESTION_DETAILS_INITIALIZATION,
    })
    apiCall(
      QUESTION_URL + `/${ID}`,
      (res: any) => dispatch(questionDetailsSuccess(res)),
      (err: any) => {
        dispatch(questionDetailsError(err))
      },
      {},
      METHOD.GET,
      { showToast: false }
    )
  }

export const questionDetailsSuccess =
  (res: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: QUESTION_DETAILS.QUESTION_DETAILS_SUCCESS,
      payload: res,
    })
  }

export const questionDetailsError =
  (err: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: QUESTION_DETAILS.QUESTION_DETAILS_ERORR,
      payload: err.message,
    })
  }

// ************** QUESTION_DELETE ******************

export const questionDelete =
  (
    ID: any,
    _handleRedirect: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(questionDeleteInit(ID, _handleRedirect))
  }

export const questionDeleteInit =
  (
    ID: any,
    _handleRedirect
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: QUESTION_DELETE.QUESTION_DELETE_INITIALIZATION,
    })
    apiCall(
      QUESTION_URL + `/${ID}`,
      (res: any) => dispatch(questionDeleteSuccess(res, _handleRedirect)),
      (err: any) => {
        dispatch(questionDeleteError(err))
      },
      {},
      METHOD.DELETE,
      { showToast: true }
    )
  }

export const questionDeleteSuccess =
  (
    res: any,
    _handleRedirect
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: QUESTION_DELETE.QUESTION_DELETE_SUCCESS,
      payload: res,
    })
    _handleRedirect()
  }

export const questionDeleteError =
  (err: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: QUESTION_DELETE.QUESTION_DELETE_ERORR,
      payload: err.message,
    })
  }

// ************** SUBJECT_LIST ******************

export const subjectList =
  (
    showToast = false,
    examType?: number,
    visibility?: string,
    userSubject?: boolean,
    havingQuestion?: boolean
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(
      subjectListInit(
        showToast,
        examType,
        visibility,
        userSubject,
        havingQuestion
      )
    )
  }

export const subjectListInit =
  (
    showToast: boolean,
    exam_type?: number,
    visibility?: string,
    userSubject?: boolean,
    havingQuestion?: boolean
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: SUBJECT_LIST.SUBJECT_LIST_INITIALIZATION,
    })
    const params = new URLSearchParams()
    if (visibility === 'All') {
      params.append('visibility', 'PUBLIC')
      params.append('visibility', 'PRIVATE')
    } else {
      visibility && params.append('visibility', visibility)
    }
    exam_type && params.append('exam_type', exam_type?.toString())
    userSubject && params.append('users_subject', userSubject?.toString())
    havingQuestion &&
      params.append('having_question', havingQuestion?.toString())
    apiCall(
      SUBJECT_URL,
      (res: any) => dispatch(subjectListSuccess(res)),
      (err: any) => {
        dispatch(subjectListError(err))
      },
      {
        params,
      },
      METHOD.GET,
      { showToast: showToast }
    )
  }

export const subjectListSuccess =
  (res: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: SUBJECT_LIST.SUBJECT_LIST_SUCCESS,
      payload: res,
    })
  }

export const subjectListError =
  (err: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: SUBJECT_LIST.SUBJECT_LIST_ERORR,
      payload: err.message,
    })
  }

// ************** TOPIC_LIST ******************

export const topicList =
  (
    showToast = false,
    id?: number | number[],
    examType?: number,
    hasQuestions?: boolean,
    visibility?: string
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(topicListInit(showToast, id, examType, hasQuestions, visibility))
  }

export const topicListInit =
  (
    showToast: boolean,
    id?: number | number[],
    examType?: number,
    hasQuestions?: boolean,
    visibility?: string
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: TOPIC_LIST.TOPIC_LIST_INITIALIZATION,
    })
    const params = new URLSearchParams()
    if (Array.isArray(id)) {
      id.forEach((uId) => {
        params?.append('id', uId?.toString())
      })
    } else {
      id && params?.append('id', id?.toString())
    }
    examType && params?.append('exam_type', examType?.toString())
    if (visibility === 'All') {
      params.append('visibility', 'PUBLIC')
      params.append('visibility', 'PRIVATE')
    } else {
      visibility && params.append('visibility', visibility)
    }
    hasQuestions && params?.append('having_question', hasQuestions?.toString())
    apiCall(
      TOPIC_URL,
      (res: any) => dispatch(topicListSuccess(res)),
      (err: any) => {
        dispatch(topicListError(err))
      },
      {
        params,
      },
      METHOD.GET,
      { showToast: showToast }
    )
  }

export const topicListSuccess =
  (res: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: TOPIC_LIST.TOPIC_LIST_SUCCESS,
      payload: res,
    })
  }

export const topicListError =
  (err: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: TOPIC_LIST.TOPIC_LIST_ERORR,
      payload: err.message,
    })
  }

// ************** BULK UPLOAD QUESTION ******************

export const bulkUploadQuestions =
  (
    showToast = false,
    payload: Record<
      string,
      string | number | File[] | File | undefined | boolean
    >,
    successRedirect: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(bulkUploadQuestionInit(showToast, successRedirect, payload))
  }

export const bulkUploadQuestionInit =
  (
    showToast: boolean,
    successRedirect: () => void,
    payload: Record<
      string,
      string | number | File[] | File | undefined | boolean
    >
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: QUESTION_BULK_UPLOAD.QUESTION_BULK_UPLOAD_INITIALIZATION,
    })
    const formPayload = new FormData()
    payload?.subject &&
      formPayload?.append('subject', payload?.subject?.toString())
    payload?.topic && formPayload?.append('topic', payload?.topic?.toString())
    formPayload?.append('exam_type', (payload?.exam_type || '')?.toString())
    ;(payload?.image as File[])?.map((image) =>
      formPayload.append('images', image)
    )
    formPayload.append('file', payload?.file as Blob)
    formPayload.append('bulk_upload_type', 'QUESTION')
    formPayload.append('language', payload?.language as string)
    formPayload.append('visibility', payload?.visibility as string)
    payload?.multiple_subject_and_topic &&
      formPayload.append(
        'multiple_subject_and_topic',
        payload?.multiple_subject_and_topic as string
      )
    apiCall(
      QUESTION_BULK_UPLOAD_URL,
      (res: any) => dispatch(bulkUploadQuestionSuccess(res, successRedirect)),
      (err: any) => dispatch(bulkUploadQuestionError(err)),
      formPayload,
      METHOD.POST,
      {
        showToast: showToast,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )
  }

export const bulkUploadQuestionSuccess =
  (
    res: any,
    successRedirect: () => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: QUESTION_BULK_UPLOAD.QUESTION_BULK_UPLOAD_SUCCESS,
      payload: res,
    })
    successRedirect()
  }

export const bulkUploadQuestionError =
  (err: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: QUESTION_BULK_UPLOAD.QUESTION_BULK_UPLOAD_ERORR,
      payload: err?.message,
    })
    showErrorToastMessage(err?.message?.file?.[0])
  }

// ************** BULK UPLOAD QUESTION LIST ******************

export const getBulkUploadQuestion =
  (
    showToast = false,
    params: Record<string, any>
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch(getBulkUploadQuestionInit(showToast, params))
  }

export const getBulkUploadQuestionInit =
  (
    showToast: boolean,
    params: Record<string, any>
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: QUESTION_BULK_UPLOAD.GET_BULK_UPLOAD_QUESTIONS_INITIALIZATION,
    })
    apiCall(
      QUESTION_BULK_UPLOAD_URL,
      (res: any) => dispatch(getBulkUploadQuestionSuccess(res)),
      (err: any) => {
        dispatch(getBulkUploadQuestionError(err))
      },
      { params },
      METHOD.GET,
      {
        showToast: showToast,
      }
    )
  }

export const getBulkUploadQuestionSuccess =
  (res: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: QUESTION_BULK_UPLOAD.GET_BULK_UPLOAD_QUESTIONS_SUCCESS,
      payload: res,
    })
  }

export const getBulkUploadQuestionError =
  (err: any): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: QUESTION_BULK_UPLOAD.GET_BULK_UPLOAD_QUESTIONS_ERORR,
      payload: err.message,
    })
  }

// ************** UPLOAD QUESTIONNAIRE ******************

export const uploadQuestionnaire =
  (
    payload: Record<string, string | number | File>,
    handleSuccess: (...args) => void,
    handleError?: (...args) => void
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: QUESTIONNAIRE_UPLOAD.QUESTIONNAIRE_UPLOAD_INITIALIZATION,
    })
    const formPayload = new FormData()
    formPayload.append('exam_type', payload?.exam_type?.toString())
    formPayload.append('file', payload?.file as string)
    formPayload.append('question_paper_name', payload?.name as string)
    payload?.question_count &&
      formPayload.append('question_count', payload?.question_count as string)
    apiCall(
      QUESTIONNAIRE_UPLOAD_URL,
      (res: any) => {
        dispatch({
          type: QUESTIONNAIRE_UPLOAD.QUESTIONNAIRE_UPLOAD_SUCCESS,
        })
        successToast('Question paper has been uploaded')
        handleSuccess(res)
      },
      (err: any) => {
        dispatch({
          type: QUESTIONNAIRE_UPLOAD.QUESTIONNAIRE_UPLOAD_ERROR,
        })
        if (!handleError) {
          showErrorToastMessage(
            err?.message?.file?.[0] ||
              'Question paper can not be uploaded. Please check error file'
          )
          !err?.message?.file?.[0] &&
            !err?.message?.non_field_errors?.[0] &&
            handleSuccess(err)
        } else {
          handleError(err)
        }
      },
      formPayload,
      METHOD.POST,
      {
        showToast: false,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    )
  }

// ************** UPLOAD QUESTIONNAIRE HISTORY ******************

export const getUploadQuestionnaireHistory =
  (page: number): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: UPLOAD_QUESTIONNAIRE_HISTORY.UPLOAD_QUESTIONNAIRE_HISTORY_INITIALIZATION,
    })
    apiCall(
      QUESTIONNAIRE_UPLOAD_HISTORY_URL,
      (res: any) => {
        dispatch({
          type: UPLOAD_QUESTIONNAIRE_HISTORY.UPLOAD_QUESTIONNAIRE_HISTORY_SUCCESS,
          payload: res?.data,
        })
      },
      () => {
        dispatch({
          type: UPLOAD_QUESTIONNAIRE_HISTORY.UPLOAD_QUESTIONNAIRE_HISTORY_ERROR,
        })
      },
      { params: { page } },
      METHOD.GET,
      {
        showToast: false,
      }
    )
  }

// ************** QUESTIONNAIRE_LIST ******************

export const questionnaireList =
  (
    page?: number,
    allocationType?: string,
    subject?: string,
    search?: string,
    ordering?: string,
    question_count_min?: number,
    cancelToken?: CancelTokenSource,
    randomize_questions?: boolean
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: QUESTIONNAIRE_LIST.QUESTIONNAIRE_LIST_INITIALIZATION,
    })
    apiCall(
      QUESTIONNAIRE_LIST_URL,
      (res: any) => {
        dispatch({
          type: QUESTIONNAIRE_LIST.QUESTIONNAIRE_LIST_SUCCESS,
          payload: res?.data,
        })
      },
      (err: any) => {
        dispatch({
          type: QUESTIONNAIRE_LIST.QUESTIONNAIRE_LIST_ERROR,
        })
        if (
          err?.data?.verification_code?.[0] ||
          err?.data?.password?.[0] ||
          err?.message
        ) {
          showErrorToastMessage(
            err?.data?.verification_code?.[0] ||
              err?.data?.password?.[0] ||
              err?.message ||
              'Something went wrong'
          )
        }
      },
      {
        params: {
          page: page || undefined,
          allocation_type: allocationType || undefined,
          subject: subject || undefined,
          search: search || undefined,
          ordering: ordering || undefined,
          question_count_min: question_count_min || undefined,
          randomize_questions: randomize_questions ?? undefined,
        },
        cancelToken: cancelToken?.token,
      },
      METHOD.GET,
      { showToast: false }
    )
  }

// ************** QUESTIONNAIRE_DETAILS ******************

export const getQuestionnaireDetails =
  (
    questionnaireId: number,
    onSuccess?: (...args) => Promise<any>,
    downloadWithoutAnswers?: boolean
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: QUESTIONNAIRE_DETAILS.QUESTIONNAIRE_DETAILS_INITIALIZATION,
    })
    apiCall(
      `${QUESTIONNAIRE_DETAILS_URL}/${questionnaireId}`,
      (res: any) => {
        dispatch({
          type: QUESTIONNAIRE_DETAILS.QUESTIONNAIRE_DETAILS_SUCCESS,
          payload: res?.data,
        })
        onSuccess && onSuccess(res?.data, downloadWithoutAnswers)
      },
      () => {
        dispatch({
          type: QUESTIONNAIRE_DETAILS.QUESTIONNAIRE_DETAILS_ERROR,
        })
      },
      {},
      METHOD.GET,
      {
        showToast: false,
      }
    )
  }

// ************** QUESTIONNAIRE_DELETE ******************

export const deleteQuestionnaire =
  (
    questionnaireId: number,
    handleSuccess?: (page?: number) => void,
    page?: number,
    pageItemLength?: number,
    setPage?: React.Dispatch<React.SetStateAction<number>>
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: QUESTIONNAIRE_DELETE.QUESTIONNAIRE_DELETE_INITIALIZATION,
    })
    apiCall(
      `${QUESTIONNAIRE_DETAILS_URL}/${questionnaireId}`,
      () => {
        dispatch({
          type: QUESTIONNAIRE_DELETE.QUESTIONNAIRE_DELETE_SUCCESS,
        })
        if (pageItemLength && pageItemLength - 1 === 0 && page && page !== 1) {
          setPage && setPage(page - 1)
        } else {
          handleSuccess && handleSuccess(page)
        }
        successToast('Question paper deleted successfully')
      },
      () => {
        dispatch({
          type: QUESTIONNAIRE_DELETE.QUESTIONNAIRE_DELETE_ERROR,
        })
      },
      {},
      METHOD.DELETE,
      {
        showToast: false,
      }
    )
  }

// ************** UPLOAD_HISTORY_DELETE ******************

export const deleteUploadHistory =
  (
    historyId: number,
    handleSuccess: (page?: number) => void,
    page?: number,
    pageItemLength?: number,
    setPage?: React.Dispatch<React.SetStateAction<number>>
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: DELETE_UPLOAD_HISTORY.DELETE_UPLOAD_HISTORY_INITIALIZATION,
    })
    apiCall(
      `${DELETE_UPLOAD_HISTORY_URL}`,
      () => {
        dispatch({
          type: DELETE_UPLOAD_HISTORY.DELETE_UPLOAD_HISTORY_SUCCESS,
        })
        if (pageItemLength && pageItemLength - 1 === 0 && page && page !== 1) {
          setPage && setPage(page - 1)
        } else {
          handleSuccess && handleSuccess(page)
        }
        successToast('History deleted successfully')
      },
      () => {
        dispatch({
          type: DELETE_UPLOAD_HISTORY.DELETE_UPLOAD_HISTORY_ERROR,
        })
      },
      {},
      METHOD.DELETE,
      {
        showToast: false,
        params: { id: historyId },
      }
    )
  }

// ************** GET QUESTION PAPER DETAILS WITHOUT QUESTION ******************

export const getQuestionPaperDetails =
  (examId: string): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: GET_QUESTION_PAPER.GET_QUESTION_PAPER_INITIALIZATION,
    })
    apiCall(
      `${GET_QUESTION_PAPER_URL?.replace('examId', examId)}`,
      (res: any) => {
        dispatch({
          type: GET_QUESTION_PAPER.GET_QUESTION_PAPER_SUCCESS,
          payload: res?.data,
        })
      },
      () => {
        dispatch({
          type: GET_QUESTION_PAPER.GET_QUESTION_PAPER_FAILED,
        })
      },
      {},
      METHOD.GET,
      {
        showToast: false,
      }
    )
  }

export const getExamQuestions =
  (examId: string): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: GET_EXAM_QUESTION.GET_EXAM_QUESTION_INITIALIZATION,
    })
    apiCall(
      `${GET_EXAM_QUESTIONS_URL?.replace('examId', examId)}`,
      (res: any) => {
        dispatch({
          type: GET_EXAM_QUESTION.GET_EXAM_QUESTION_SUCCESS,
          payload: res?.data,
        })
      },
      () => {
        dispatch({
          type: GET_EXAM_QUESTION.GET_EXAM_QUESTION_FAILED,
        })
      },
      {},
      METHOD.GET,
      {
        showToast: false,
      }
    )
  }

// GET EXAM TYPE WISE SUBJECT LIST

export const getExamTypeWiseSubjects =
  (
    params: Record<string, string | number>
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: EXAM_TYPE_WISE_SUBJECT_LIST.EXAM_TYPE_WISE_SUBJECT_LIST_INITIALIZATION,
    })
    apiCall(
      EXAM_TYPE_WISE_SUBJECT_LIST_URL,
      (res: any) => {
        dispatch({
          type: EXAM_TYPE_WISE_SUBJECT_LIST.EXAM_TYPE_WISE_SUBJECT_LIST_SUCCESS,
          payload: res,
        })
      },
      () => {
        dispatch({
          type: EXAM_TYPE_WISE_SUBJECT_LIST.EXAM_TYPE_WISE_SUBJECT_LIST_ERORR,
        })
      },
      { params },
      METHOD.GET,
      {
        showToast: false,
      }
    )
  }

export const getSubjectWiseTopics =
  (
    params: Record<string, string | number>
  ): ThunkAction<void, Store, unknown, Action<string>> =>
  (dispatch) => {
    dispatch({
      type: SUBJECT_WISE_TOPIC_LIST.SUBJECT_WISE_TOPIC_LIST_INITIALIZATION,
    })
    apiCall(
      SUBJECT_WISE_TOPICS_URL,
      (res: any) => {
        dispatch({
          type: SUBJECT_WISE_TOPIC_LIST.SUBJECT_WISE_TOPIC_LIST_SUCCESS,
          payload: res,
        })
      },
      () => {
        dispatch({
          type: SUBJECT_WISE_TOPIC_LIST.SUBJECT_WISE_TOPIC_LIST_ERORR,
        })
      },
      { params },
      METHOD.GET,
      {
        showToast: false,
      }
    )
  }
